module.exports = __webpack_public_path__ + "img/18@2x.e38aa40.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/cooperation/18@2x.png
// module id = 1y8f
// module chunks = 0